import { render, staticRenderFns } from "./Pitches.vue?vue&type=template&id=358c9a28&scoped=true"
import script from "./Pitches.vue?vue&type=script&lang=js"
export * from "./Pitches.vue?vue&type=script&lang=js"
import style0 from "./Pitches.vue?vue&type=style&index=0&id=358c9a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c9a28",
  null
  
)

export default component.exports